import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';

import {
  TXTMOB_Be_the_first_to_know_about_off_ELL,
  TXTMOB_Choose_your_marketing_preferen_ELL,
  TXTWCL_Marketing_preferences
} from './SignupConsent.messages.json';
import Fields from './components/Fields';

const SignupConsent: React.FC = () => (
  <Container
    page={SignupConsent}
    headerProps={{ title: <Translation {...TXTWCL_Marketing_preferences} /> }}
    pageTopTitle={<Translation {...TXTMOB_Choose_your_marketing_preferen_ELL} />}
    pageTopSubtitle={<Translation {...TXTMOB_Be_the_first_to_know_about_off_ELL} />}
  >
    <Fields />
    <CTAButton />
  </Container>
);

SignupConsent.displayName = 'SignupConsent';

export default SignupConsent;
